import { axios } from '@/utils/request'

const API = {
  classesInfoDetail: '/b/classes/biz/studentClasses/v2/detail', // 获取我的课程信息
  resource: '/b/classes/biz/classes/schedule/resource/getById', // 课程资源
  studentPlanclasses: '/b/classes/biz/studentPlanclasses/v2/detail', // 班级详情
  studentOverdueclasses: '/b/classes/biz/studentClasses/v2/myClassesInfoList', // 班级详情过期课程
  subjectTree: '/b/classes/biz/studentClasses/v2/subject/tree', // 课程目录
  schedule: '/b/classes/biz/student/schedule/v2/list', // 直播列表
  getClassesInfoList: '/b/classes/biz/studentClasses/v2/myClassesInfoList',
  stars: '/b/classes/biz/scheduleAppraise/conf/stars',
  getOpenSchedulePage: '/b/classes/study/plan/v2/getOpenSchedulePage',
  getOpenSchedulePageV2: '/b/classes/study/plan/v2/getOpenSchedulePage',
  addStart: '/b/classes/biz/studentScheduleAppraise/v2/save',
  detail: '/b/classes/biz/studentClasses/v2/attach/detail', // 附加课详情
  exam: '/b/classes/biz/classes/schedule/exam/v2/get', // 作业
  examSubmit: '/b/classes/biz/student/exam/v2/schedule/submit', // 试卷提交
  getExamRank: '/b/classes/biz/student/exam/v2/getExamRank', // 获取试卷排行
  openDetail: '/b/classes/biz/studentClasses/v2/open/detail', // 公开课详情
  openList: '/b/classes/biz/student/schedule/v2/open/list', // 公开课直播列表
  openSign: '/b/classes/biz/studentClasses/v2/openSign' // 报名公开课
}
// 获取我的课程详情
export const getMyClassDetail = data => {
  return axios({
    url: API.classesInfoDetail,
    method: 'GET',
    params: data
  })
}
export const getMyClassList = data => {
  return axios({
    url: API.getClassesInfoList,
    method: 'GET',
    params: data
  })
}
export const subjectTree = data => {
  return axios({
    url: API.subjectTree,
    method: 'GET',
    params: data
  })
}
export const schedule = data => {
  return axios({
    url: API.schedule,
    method: 'GET',
    params: data
  })
}

export const studentPlanclasses = data => {
  return axios({
    url: API.studentPlanclasses,
    method: 'GET',
    params: data
  })
}
export const studentOverdueclasses = data => {
  return axios({
    url: API.studentOverdueclasses,
    method: 'GET',
    params: data
  })
}

export const resource = data => {
  return axios({
    url: API.resource,
    method: 'GET',
    params: data
  })
}
export const stars = data => {
  return axios({
    url: API.stars,
    method: 'GET',
    params: data
  })
}

export const getOpenSchedulePage = data => {
  return axios({
    url: API.getOpenSchedulePageV2,
    method: 'GET',
    params: data
  })
}

export const addStart = data => {
  return axios({
    url: API.addStart,
    method: 'POST',
    data
  })
}

export const AddDetail = data => {
  return axios({
    url: API.detail,
    method: 'GET',
    params: data
  })
}

export const openDetail = data => {
  return axios({
    url: API.openDetail,
    method: 'GET',
    params: data
  })
}
export const openSign = data => {
  return axios({
    url: API.openSign,
    method: 'GET',
    params: data
    // headers: {
    //   ocode: 'accdev',
    //   oid: '312523cacd5176057e7f3dd97a212d79'
    // },
  })
}

export const openList = data => {
  return axios({
    url: API.openList,
    method: 'GET',
    params: data
    // headers: {
    //   ocode: 'accdev',
    //   oid: '312523cacd5176057e7f3dd97a212d79'
    // },
  })
}
// 获取学员作业
export const feachExam = params => {
  return axios({
    url: API.exam,
    method: 'GET',
    params
  })
}

// 试卷提交
export const examSubmit = data => {
  return axios({
    url: API.examSubmit,
    method: 'POST',
    data
  })
}

// 获取试卷排行
export const getExamRank = params => {
  return axios({
    url: API.getExamRank,
    method: 'GET',
    params
  })
}
